import React, { Component } from "react";

import { Formik, Form } from "formik";
import { IconTextInput, CheckboxInput } from "../../../../forms/components";

import { addNewRates } from "../../../../libs/functions";

import Swal from "sweetalert2";
import Util from "../../../../libs/util";

class ManageNewStripeRates extends Component {
	constructor(props) {
		super(props);

		this.state = {
			paymentTypes: Object.keys(props.MDRTypes),
			initialValues: this.getInitialValues(),
		};

		this.newStripeRatesModalRef = React.createRef();
	}

	componentDidUpdate(prevProps) {
		if (
			JSON.stringify(prevProps.baseRate) !== JSON.stringify(this.props.baseRate)
		)
			this.setState({ initialValues: this.getInitialValues() });
	}

	getInitialValues = () => {
		const { baseRate } = this.props;
		const { default: defaultRate, under, ...paymentTypes } = baseRate;
		let initialValues = {
			rates: {
				...baseRate,
			},
			enable: {},
		};

		for (let type in paymentTypes) {
			initialValues.enable[type] = true;
		}

		return initialValues;
	};

	closeModal = () => {
		return Util.hideModal("manage-new-stripe-rates").then(() => {
			this.newStripeRatesModalRef.current.remove();
		});
	};

	addRates = (values, { resetForm }) => {
		Swal.fire({
			title: "Adding new rates",
			onBeforeOpen: () => {
				this.closeModal().then(() => {
					resetForm();
				});
				Swal.showLoading();
			},
			onOpen: async () => {
				try {
					const { merchant, gateway } = this.props;
					let status = await addNewRates({
						merchant: merchant.id,
						gateway,
						...values,
					});
					if (status) {
						Swal.fire({
							icon: "success",
							title: "Rates Added",
						}).then(async () => {
							this.props.retrieveMerchants(true);
						});
					}
				} catch (err) {
					Swal.fire({
						icon: "error",
						title: `Unable to add new rates`,
						onClose: () => {},
					});
				}
			},
		});
	};

	render() {
		const { MDRTypes, baseRate, gateway } = this.props;
		const { paymentTypes, initialValues } = this.state;
		return (
			<div
				id="manage-new-stripe-rates"
				className="uk-modal-container"
				uk-modal="stack: true"
				ref={this.newStripeRatesModalRef}
			>
				<div className="uk-modal-dialog uk-modal-body">
					<h2 className="uk-modal-title">Add Transaction Fees for Stripe</h2>
					<Formik
						initialValues={initialValues}
						enableReinitialize={true}
						onSubmit={this.addRates}
					>
						{(props) => {
							return (
								<Form onSubmit={props.handleSubmit}>
									<div className="uk-overflow-auto" style={{ height: "40vh" }}>
										<div className="new-merchant-rate-table uk-overflow-auto uk-margin-small-bottom">
											<table className="uk-table uk-table-striped uk-table-middle">
												<thead>
													<tr>
														<th>Type</th>
														<th>Percentage</th>
														<th>Fixed Fees</th>
													</tr>
												</thead>
												<tbody>
													<tr>
														<td>Default</td>
														<td>
															<IconTextInput
																id={`rates.default.percent`}
																name={`rates.default.percent`}
																icon="fa-solid-percent; ratio: 0.5"
																iconFlip={true}
																type="number"
																step=".01"
																min={baseRate.default.percent}
																placeholder="Percentage"
															/>
														</td>
														<td>
															<IconTextInput
																id={`rates.default.fixed`}
																name={`rates.default.fixed`}
																icon="fa-solid-dollar-sign; ratio: 0.5"
																type="number"
																step=".01"
																min={baseRate.default.fixed}
																placeholder="Fixed Fees"
															/>
														</td>
													</tr>
													{baseRate.under.map(
														({ amountInCents, percent, fixed }, index) => (
															<tr key={index}>
																<td>
																	Under ${(amountInCents / 100).toFixed(2)}
																</td>
																<td>
																	<IconTextInput
																		id={`rates.under[${index}].percent`}
																		name={`rates.under[${index}].percent`}
																		icon="fa-solid-percent; ratio: 0.5"
																		iconFlip={true}
																		type="number"
																		step=".01"
																		min={percent}
																		placeholder="Percentage"
																	/>
																</td>
																<td>
																	<IconTextInput
																		id={`rates.under[${index}].fixed`}
																		name={`rates.under[${index}].fixed`}
																		icon="fa-solid-dollar-sign; ratio: 0.5"
																		type="number"
																		step=".01"
																		min={fixed}
																		placeholder="Fixed Fees"
																	/>
																</td>
															</tr>
														)
													)}
												</tbody>
											</table>
										</div>
										<div className="new-merchant-rate-table uk-overflow-auto uk-margin-bottom">
											<table className="uk-table uk-table-striped uk-table-middle">
												<thead>
													<tr>
														<th>Payment Type</th>
														<th>Percentage</th>
														<th>Fixed Fees</th>
														<th className="uk-width-1-6">Enabled</th>
													</tr>
												</thead>
												<tbody>
													{paymentTypes.map((type) => {
														let paymentRate = baseRate[type];
														if (paymentRate) {
															let isDisabled = props.values.enable
																? !props.values.enable[type]
																: false;
															return (
																<tr key={`${gateway}-${type}-rate`}>
																	<td>
																		<img
																			className="uk-img"
																			src={`data:image/*;base64,${MDRTypes[type].image}`}
																			width="35"
																		/>
																		<span className="uk-margin-small-left">
																			{MDRTypes[type].label}
																		</span>
																	</td>
																	<td>
																		<IconTextInput
																			id={`rates.${type}.percent`}
																			name={`rates.${type}.percent`}
																			icon="fa-solid-percent; ratio: 0.5"
																			iconFlip={true}
																			type="number"
																			step=".01"
																			min={paymentRate.percent}
																			placeholder="Percentage"
																			disabled={isDisabled}
																		/>
																	</td>
																	<td>
																		<IconTextInput
																			id={`rates.${type}.fixed`}
																			name={`rates.${type}.fixed`}
																			icon="fa-solid-dollar-sign; ratio: 0.5"
																			type="number"
																			step=".01"
																			min={paymentRate.fixed}
																			placeholder="Fixed Fees"
																			disabled={
																				isDisabled || !paymentRate.fixed
																			}
																		/>
																	</td>
																	<td className="uk-width-1-5 uk-text-center">
																		<CheckboxInput
																			id={`enable.${type}`}
																			name={`enable.${type}`}
																		/>
																	</td>
																</tr>
															);
														}
													})}
												</tbody>
											</table>
										</div>
									</div>
									<p className="uk-text-right">
										<button
											className="uk-button uk-button-default uk-modal-close"
											type="button"
										>
											Cancel
										</button>
										<button
											className="uk-button uk-button-primary"
											type="submit"
										>
											Add
										</button>
									</p>
								</Form>
							);
						}}
					</Formik>
				</div>
			</div>
		);
	}
}

export default ManageNewStripeRates;
